export const getOverviewParamName = (type: string) => {
  switch (type) {
    case 'views':
      return 'Page Views'
    case 'new_visitors':
      return 'New Visitors'
    case 'total_visitors':
      return 'Visitors'
    case 'returning_visitors':
      return 'Returning Visitors'
    case 'new_customers':
      return 'New Customers'
    case 'total_customers':
      return 'Customers'
    case 'returning_customers':
      return 'Returning Customers'
    case 'form_submits':
      return 'Forms'
    case 'leads':
      return 'New Leads'
    case 'total_orders':
      return 'Orders'
    case 'total_amount':
      return 'Total Sales'
    case 'orders_amount':
      return 'Initial Sales'
    case 'recurring_payments_amount':
      return 'Recurring Sales'
    default:
      return 'Page Views'
  }
}

export const getStatsParamName = (type: string) => {
  switch (type) {
    case 'views':
      return 'Visitors'
    case 'form_submits':
      return 'Forms'
    case 'leads':
      return 'New Leads'
    case 'total_orders':
      return 'Orders'
    case 'total_amount':
      return 'Total Sales'
    case 'orders_amount':
      return 'Initial Sales'
    case 'recurring_payments_amount':
      return 'Recurring Sales'
    default:
      return 'Visitors'
  }
}
